    import { useState } from 'react';
import nhost from '../nhost';
import ImageUpload from './ImageUpload';

export default function WineEditModal({ wine, isAdmin, onClose, onSaved }) {
  const [name, setName] = useState(wine.name || '');
  const [grape, setGrape] = useState(wine.grape || '');
  const [type, setType] = useState(wine.type || 'Rött');
  const [country, setCountry] = useState(wine.country || '');
  const [region, setRegion] = useState(wine.region || '');
  const [vintage, setVintage] = useState(wine.vintage ? String(wine.vintage) : '');
  const [price, setPrice] = useState(wine.price ? String(wine.price) : '');
  const [packaging, setPackaging] = useState(wine.packaging || '');
  const [profileSource, setProfileSource] = useState(wine.profile_source || '');
  const [profileText, setProfileText] = useState(wine.profile || '');
  const [imageUrl, setImageUrl] = useState(wine.image_url || null);
  const [saving, setSaving] = useState(false);

  async function deleteWine() {
    if (!window.confirm(`Är du säker på att du vill ta bort "${wine.name}"? Det går inte att ångra.`)) return;
    setSaving(true);
    try {
      await nhost.graphql.request(`mutation {
        delete_ratings(where: { wine_id: { _eq: "${wine.id}" } }) { affected_rows }
        delete_wine_interests(where: { wine_id: { _eq: "${wine.id}" } }) { affected_rows }
      }`);

      const delRes = await nhost.graphql.request(`mutation { delete_wines_by_pk(id: "${wine.id}") { id } }`);

      if (!delRes?.data?.delete_wines_by_pk) {
        alert('Borttagning misslyckades – se console för detaljer.');
        setSaving(false);
        return;
      }
      onSaved();
    } catch (e) {
      console.error('deleteWine error:', e);
      alert('Undantag: ' + e.message);
      setSaving(false);
    }
  }

  async function save() {
    if (!name.trim()) { alert('Ange vinets namn'); return; }
    setSaving(true);
    await nhost.graphql.request(`
      mutation UpdateWine($id: uuid!, $changes: wines_set_input!) {
        update_wines_by_pk(pk_columns: { id: $id }, _set: $changes) { id }
      }
    `, {
      id: wine.id,
      changes: {
        name: name.trim(),
        grape: grape || null,
        type,
        country: country || null,
        region: region || null,
        vintage: vintage ? parseInt(vintage) : null,
        price: price ? parseInt(price) : null,
        packaging: packaging || null,
        profile: profileText || null,
        profile_source: profileSource || null,
        image_url: imageUrl || null,
      }
    });
    setSaving(false);
    onSaved();
  }

  return (
    <div className="modal-bg" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-handle" />
        <div className="modal-title">Redigera vin</div>

        <div className="field" style={{ alignItems: 'center' }}>
          <ImageUpload
            currentUrl={imageUrl}
            onUploaded={setImageUrl}
            size={80}
            shape="rounded"
            label={imageUrl ? 'Byt bild' : 'Lägg till bild'}
            showCamera
          />
        </div>

        <div className="field"><label>Vinets namn</label><input value={name} onChange={e => setName(e.target.value)} /></div>
        <div className="field"><label>Druva</label><input value={grape} onChange={e => setGrape(e.target.value)} placeholder="t.ex. Cabernet Sauvignon" /></div>
        <div className="field">
          <label>Vintyp</label>
          <select value={type} onChange={e => setType(e.target.value)}>
            <option>Rött</option><option>Vitt</option><option>Rosé</option><option>Mousserande</option><option>Dessertvin</option>
          </select>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <div className="field" style={{ marginBottom: 0 }}>
            <label>Land</label>
            <input value={country} onChange={e => setCountry(e.target.value)} placeholder="t.ex. Frankrike" />
          </div>
          <div className="field" style={{ marginBottom: 0 }}>
            <label>Region</label>
            <input value={region} onChange={e => setRegion(e.target.value)} placeholder="t.ex. Bordeaux" />
          </div>
        </div>
        <div style={{ marginBottom: 14 }} />
        <div className="field"><label>Årgång</label><input type="number" value={vintage} onChange={e => setVintage(e.target.value)} placeholder="t.ex. 2019" /></div>
        <div className="field"><label>Pris (kr)</label><input type="number" value={price} onChange={e => setPrice(e.target.value)} placeholder="t.ex. 149" /></div>
        <div className="field"><label>Förpackning</label><input value={packaging} onChange={e => setPackaging(e.target.value)} placeholder="t.ex. Glasflaska, Tetra, PET-flaska" /></div>
        <div className="field">
          <label>Smakprofil – källa</label>
          <select value={profileSource} onChange={e => setProfileSource(e.target.value)}>
            <option value="">Välj källa...</option>
            <option>Systembolaget</option><option>Vivino</option><option>Winefinder</option>
            <option>Producenten</option><option>Wine Spectator</option><option>Annan källa</option>
          </select>
        </div>
        <div className="field">
          <label>Smakbeskrivning</label>
          <textarea value={profileText} onChange={e => setProfileText(e.target.value)} placeholder="Klistra in eller skriv smakprofilen..." />
        </div>

        <div className="btn-row">
          <button className="btn-secondary" onClick={onClose}>Avbryt</button>
          <button className="btn-primary" onClick={save} disabled={saving}>{saving ? 'Sparar...' : 'Spara ändringar'}</button>
        </div>
        {isAdmin && (
          <button
            onClick={deleteWine}
            disabled={saving}
            style={{ width: '100%', marginTop: 8, padding: '10px', background: 'none', border: '0.5px solid #e57373', borderRadius: 'var(--radius)', color: '#c62828', fontSize: 13, cursor: 'pointer', fontFamily: 'inherit' }}
          >
            🗑 Ta bort vin
          </button>
        )}
      </div>
    </div>
  );
}

    
